exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-3QthH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0;overflow:hidden;text-overflow:ellipsis;margin-right:40px;padding:0;height:60px;border:none;background-color:rgba(0,0,0,0);color:#fff;font-weight:600;cursor:pointer;-webkit-transition:.3s;transition:.3s}.tab-3QthH:focus{outline:none}.tab-3QthH:last-child{margin-right:0}.active-33_GP{color:#fff}.disabled-3Yt2E{color:rgba(255,255,255,.5);cursor:not-allowed}.theme-dark .tab-3QthH{color:#fff}.theme-dark .active-33_GP{color:#fff}.theme-light .tab-3QthH{color:#212121}.theme-light .active-33_GP{color:#1d94c1}", ""]);

// exports
exports.locals = {
	"tab": "tab-3QthH",
	"active": "active-33_GP",
	"disabled": "disabled-3Yt2E"
};